module.exports = new __parcel__URL__("empty-state-workflow-work-suggestions.d100b944.svg").toString();